/* NXT sportswear — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var R = (window.NXT && window.NXT.routes) || {};
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- overlays */
  var scrollLocked = 0;
  function lockScroll(on) {
    scrollLocked = Math.max(0, scrollLocked + (on ? 1 : -1));
    document.body.style.overflow = scrollLocked > 0 ? 'hidden' : '';
  }
  function setOpen(el, open) {
    if (!el) return;
    el.setAttribute('data-open', open ? 'true' : 'false');
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    lockScroll(open);
  }

  var mnav   = $('[data-mnav]');
  var drawer = $('[data-cart-drawer]');
  var search = $('[data-search]');

  function closeAll() {
    [mnav, drawer, search].forEach(function (el) {
      if (el && el.getAttribute('data-open') === 'true') setOpen(el, false);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-mnav-open]'))  { e.preventDefault(); setOpen(mnav, true); }
    if (t.closest('[data-mnav-close]')) { e.preventDefault(); setOpen(mnav, false); }

    if (t.closest('[data-search-open]')) {
      e.preventDefault(); setOpen(search, true);
      var inp = $('[data-search-input]');
      if (inp) setTimeout(function () { inp.focus(); }, 60);
    }
    if (t.closest('[data-search-close]')) { e.preventDefault(); setOpen(search, false); }

    /* cart icon opens the drawer instead of navigating (unless on the cart page) */
    var cartBtn = t.closest('[data-cart-open]');
    if (cartBtn && drawer && document.body.className.indexOf('template-cart') === -1) {
      e.preventDefault(); setOpen(drawer, true);
    }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); setOpen(drawer, false); }

    /* mobile nav accordions */
    var mt = t.closest('[data-mnav-toggle]');
    if (mt) {
      var open = mt.getAttribute('aria-expanded') === 'true';
      mt.setAttribute('aria-expanded', String(!open));
      var sub = mt.nextElementSibling;
      if (sub) sub.setAttribute('data-open', String(!open));
    }

    /* generic accordions (PDP, facets) */
    var ac = t.closest('[data-accordion-btn]');
    if (ac) {
      var isOpen = ac.getAttribute('aria-expanded') === 'true';
      ac.setAttribute('aria-expanded', String(!isOpen));
      var panel = ac.nextElementSibling;
      if (panel) panel.setAttribute('data-open', String(!isOpen));
    }

    /* mobile facet panel */
    if (t.closest('[data-facets-open]'))  { e.preventDefault(); var f = $('[data-facets]'); if (f) { f.setAttribute('data-mobile-open','true'); lockScroll(true); } }
    if (t.closest('[data-facets-close]')) { e.preventDefault(); var f2 = $('[data-facets]'); if (f2) { f2.setAttribute('data-mobile-open','false'); lockScroll(false); } }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ------------------------------------------------------------- mega menus */
  var megaTimer;
  $$('[data-mega-root]').forEach(function (root) {
    var trigger = $('[data-mega-trigger]', root);
    var panel   = $('[data-mega-panel]', root);
    if (!trigger || !panel) return;

    function open(on) {
      clearTimeout(megaTimer);
      if (on) {
        $$('[data-mega-panel]').forEach(function (p) { if (p !== panel) p.setAttribute('data-open', 'false'); });
      }
      panel.setAttribute('data-open', on ? 'true' : 'false');
      trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    root.addEventListener('mouseenter', function () { open(true); });
    root.addEventListener('mouseleave', function () { megaTimer = setTimeout(function () { open(false); }, 120); });
    trigger.addEventListener('focus', function () { open(true); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) open(false);
    });
    /* keyboard / touch: first tap opens rather than navigates */
    trigger.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches && panel.getAttribute('data-open') !== 'true') {
        e.preventDefault(); open(true);
      }
    });
  });

  /* ------------------------------------------------------- announcement bar */
  var slides = $$('[data-announcement-slide]');
  if (slides.length > 1) {
    var idx = 0;
    setInterval(function () {
      slides[idx].hidden = true;
      idx = (idx + 1) % slides.length;
      slides[idx].hidden = false;
    }, 5000);
  }

  /* ------------------------------------------------------------------- cart */
  function money(cents) {
    var fmt = (window.NXT && window.NXT.moneyFormat) || '{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* Re-render the drawer from the Cart API + a section render of the lines. */
  function renderCart() {
    return fetch(R.cart + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = $('[data-cart-count]');
        if (count) {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        }
        var countText = $('[data-cart-count-text]');
        if (countText) countText.textContent = '(' + cart.item_count + ')';
        var sub = $('[data-cart-subtotal]');
        if (sub) sub.textContent = money(cart.total_price);
        var foot = $('[data-cart-foot]');
        if (foot) foot.hidden = cart.item_count === 0;
        return cart;
      })
      .then(function (cart) {
        /* pull freshly-rendered line markup */
        return fetch(window.location.pathname + '?section_id=cart-lines', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            var body = $('[data-cart-body]');
            if (html && body) {
              var tmp = document.createElement('div');
              tmp.innerHTML = html;
              var inner = tmp.querySelector('[data-cart-lines-root]');
              if (inner) body.innerHTML = inner.innerHTML;
            }
            return cart;
          })
          .catch(function () { return cart; });
      });
  }

  function changeLine(key, qty) {
    var body = $('[data-cart-body]');
    if (body) body.classList.add('loading');
    return fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { return renderCart(); })
      .catch(function () { window.location.href = R.cart; })
      .finally(function () { if (body) body.classList.remove('loading'); });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-line-key'), 0); return; }

    var up = e.target.closest('[data-qty-up]');
    var dn = e.target.closest('[data-qty-down]');
    if (up || dn) {
      e.preventDefault();
      var wrap = (up || dn).parentElement;
      var input = $('input', wrap);
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      var next = Math.max(0, val + (up ? 1 : -1));
      input.value = next;
      var key = input.getAttribute('data-line-key');
      if (key) changeLine(key, next);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var key = input.getAttribute('data-line-key');
    if (key) changeLine(key, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* add to cart (PDP + quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.product-form, [data-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }

    fetch(R.cart_add, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && res.data.description) || 'error');
        return renderCart().then(function () { setOpen(drawer, true); });
      })
      .catch(function (err) {
        var msg = $('[data-add-error]', form);
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
      });
  });

  /* -------------------------------------------------------- predictive search */
  var sInput = $('[data-search-input]');
  var sOut   = $('[data-search-results]');
  if (sInput && sOut && R.predictive) {
    var timer, controller;
    sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { sOut.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = R.predictive + '?q=' + encodeURIComponent(q) +
                  '&resources[type]=product,collection&resources[limit]=8';
        fetch(url, { signal: controller.signal, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results) || {};
            var products = items.products || [];
            var colls = items.collections || [];
            var html = '';
            colls.slice(0, 3).forEach(function (c) {
              html += '<a class="predictive__item" href="' + c.url + '">' +
                      '<span></span><span><strong>' + c.title + '</strong></span><span></span></a>';
            });
            products.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '<span></span>';
              html += '<a class="predictive__item" href="' + p.url + '">' + img +
                      '<span>' + p.title + '</span>' +
                      '<strong>' + (p.price ? money(p.price) : '') + '</strong></a>';
            });
            if (!html) html = '<p class="muted" style="padding:12px 4px">' + '—' + '</p>';
            sOut.innerHTML = html;
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ------------------------------------------------------------- collection sort */
  var sortSel = $('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortSel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  /* keep the sticky header height in sync for sticky offsets */
  var header = $('[data-header]');
  if (header) {
    var setH = function () {
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    };
    setH();
    window.addEventListener('resize', setH);
  }

  /* carousels: click-and-drag scrolling for mouse users (touch/trackpad scroll natively) */
  document.querySelectorAll('[data-tiles-track]').forEach(function (track) {
    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        var left = track.scrollLeft;
        track.classList.remove('is-dragging');
        track.scrollLeft = left;
      }
    });
    /* a drag must not count as a click on the tile/card underneath */
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  });
})();
